import { useMemo } from 'react';

import { ActivityLogsResponse, api } from '@/api';
import { useStudyGuard } from '@/shared/guard';
import { useReportStore } from '@/store';

export const useGetActivityLogs = () => {
  const { studyId } = useStudyGuard();
  const { report } = useReportStore();

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, status } =
    api.fct.activityLogs.query.useGetActivityLogs({
      payload: {
        params: {
          report_uuid: report?.uuid,
          study_id: studyId,
        },
      },
    });

  // TODO: Add better typing to api resource for infinite queries
  // data response is transformed to { pages: ActivityLogsResponse[] }
  // so we need to flatten the pages to get the items
  const items = useMemo(
    () =>
      (data as unknown as { pages: ActivityLogsResponse[] })?.pages.flatMap((page) => page.items) ||
      [],
    [data],
  );

  return {
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    items,
    status,
  };
};
